import script from "./CoreAnnualProgramsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreAnnualProgramsView.vue?vue&type=script&setup=true&lang=js"

import "./CoreAnnualProgramsView.vue?vue&type=style&index=0&id=62fee150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fee150"]])

export default __exports__